import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-4 pt-5" }
const _hoisted_2 = { class: "text-sm flex items-center" }
const _hoisted_3 = {
  key: 0,
  class: "relative min-h-300"
}
const _hoisted_4 = {
  key: 1,
  class: "relative"
}
const _hoisted_5 = { class: "text-md" }
const _hoisted_6 = { class: "mb-8" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex mb-4 py-2 bg-blue-100 -mx-4 px-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-12 pr-2" }, "Valid"),
  /*#__PURE__*/_createElementVNode("p", { class: "w-1/4 pr-2" }, "Type"),
  /*#__PURE__*/_createElementVNode("p", { class: "w-1/4 pr-2" }, "Hostname"),
  /*#__PURE__*/_createElementVNode("p", { class: "w-1/4 pr-2" }, " Enter this value "),
  /*#__PURE__*/_createElementVNode("p", { class: "w-1/4" }, "Current value")
], -1)
const _hoisted_8 = { class: "flex text-sm mb-2" }
const _hoisted_9 = { class: "w-12 pr-2 pt-0.5 pl-2" }
const _hoisted_10 = { class: "w-1/4 pr-2" }
const _hoisted_11 = { class: "w-1/4 pr-2" }
const _hoisted_12 = { class: "w-1/4 pr-2 break-all" }
const _hoisted_13 = { class: "w-1/4 break-all" }
const _hoisted_14 = { class: "flex justify-end" }

import { required } from '@vuelidate/validators';
import {
	UiButton,
	SvgIcon,
	UiCardDivider,
	UiConfirmation,
	UiCard,
	UiForm,
	UiInput,
	UiLoader,
	UiLine,
	useForm,
	useLoading,
	useToggle
} from '@/ui-kit';
import { useDomains } from '../use-domains';
import { computed } from '@vue/reactivity';
import { watch, ref, onMounted } from 'vue';
import { useToast } from 'vue-toastification';
import { useRoute, useRouter } from 'vue-router';
import toastification from '@/plugins/toastification';
import { useEmails } from '../use-emails';


export default /*#__PURE__*/_defineComponent({
  __name: 'DomainDetails',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const {
	loading: deleteLoading,
	toggleLoading: toggleDeleteLoading
} = useLoading();
const {
	loadEmailDetails,
	removeEmail,
	selectedEmail,
	updateEmail,
	setEmail
} = useEmails();
const {
	loading: detailsLoading,
	toggleLoading: toggleDetailsLoading
} = useLoading(true);
const { success, warning } = useToast();
const confirmationRef =
	ref<InstanceType<typeof UiConfirmation>>();
const { verifyDomain, verificationLoading } = useDomains();

async function triggerVerifyDomain(id: number) {
	const domain = await verifyDomain(id);
	const valid = domain.sending_dns_records.every(
		(domain) => domain.valid === 'valid'
	);
	setEmail({
		...selectedEmail.value!,
		domain,
		valid
	});
}

function triggerDeleteCustomDomain() {
	confirmationRef.value?.openDialog(
		`Delete ${selectedEmail.value?.name}?`,
		`You won't be able to use this email in messaging.`
	);
}

const {
	formData,
	loading,
	onSubmit,
	isFormChanged,
	fillFormData
} = useForm(
	{
		name: '',
		email: ''
	},
	{
		name: {
			required
		},
		email: {
			required
		}
	}
);

const sendingDns = computed(() => {
	if (!selectedEmail.value) {
		return null;
	}

	return selectedEmail.value.domain.sending_dns_records;
});

watch(
	selectedEmail,
	() => {
		if (selectedEmail.value) {
			fillFormData(selectedEmail.value);
		}
	},
	{ immediate: true }
);

const submit = onSubmit(async (data) => {
	await updateEmail(selectedEmail.value!.id, data);
	success('Email was successfully updated.');
});

async function deleteDomain() {
	toggleDeleteLoading(true);
	await removeEmail(selectedEmail.value!.id);
	router.push({ name: 'EmailsList' });
	success('Email was successfully removed.');
}

onMounted(async () => {
	await loadEmailDetails(route.params.emailId as string);
	toggleDetailsLoading();
});

const isDisabled = computed(
	() => !isFormChanged(selectedEmail.value)
);

watch(selectedEmail, () => {
	if (!selectedEmail.value && !deleteLoading.value) {
		warning('Email was removed.');
		return router.replace({ name: 'EmailsList' });
	}
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_RouterLink, { to: { name: 'EmailsList' } }, {
        default: _withCtx(() => [
          _createVNode(_unref(UiButton), {
            class: "mb-2",
            theme: "transparent !h-8 !w-auto !min-w-auto !px-2 -mx-2"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(SvgIcon), {
                  name: "arrow",
                  class: "h-3 w-3 mr-2 transform rotate-180"
                }),
                _createTextVNode("Back to emails ")
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_unref(detailsLoading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_unref(UiLoader), {
              wrapperClass: "base text-reverse",
              loadingText: "Loading email details..."
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_unref(UiCardDivider), {
              title: _unref(selectedEmail)?.name,
              subtitle: `Settings related to email ${_unref(selectedEmail)?.email}`
            }, null, 8, ["title", "subtitle"]),
            _createVNode(_unref(UiCard), {
              class: "mb-4",
              theme: "white"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(UiCardDivider), { title: "Receiving emails" }),
                _createElementVNode("p", _hoisted_5, [
                  _createTextVNode(" To receive emails configure forwarding in your email client to "),
                  _createElementVNode("b", null, _toDisplayString(_unref(selectedEmail)?.hash), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(UiCard), {
              class: "mb-4",
              theme: "white"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(UiCardDivider), { title: "General information" }),
                _createVNode(_unref(UiForm), {
                  onSubmit: _unref(submit),
                  class: "max-w-sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(UiInput), {
                      disabled: _unref(loading),
                      label: "Friendly name",
                      placeholder: "My Email",
                      name: "name",
                      modelValue: _unref(formData).name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).name) = $event))
                    }, null, 8, ["disabled", "modelValue"]),
                    _createVNode(_unref(UiInput), {
                      disabled: "",
                      label: "Email",
                      name: "email",
                      modelValue: _unref(formData).email,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).email) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_unref(UiButton), {
                      loading: _unref(loading),
                      class: "!h-10",
                      disabled: _unref(isDisabled)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Update ")
                      ]),
                      _: 1
                    }, 8, ["loading", "disabled"])
                  ]),
                  _: 1
                }, 8, ["onSubmit"])
              ]),
              _: 1
            }),
            _createVNode(_unref(UiCard), { theme: "white" }, {
              default: _withCtx(() => [
                _createVNode(_unref(UiCardDivider), {
                  title: "Sending emails",
                  subtitle: "Set this sending DNS TXT records (known as SPF & DKIM) are required to send email"
                }),
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sendingDns), (record, i) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_unref(SvgIcon), {
                            class: _normalizeClass([
										'h-4 w-4',
										record.valid !==
										'unknown'
											? 'text-green-400'
											: 'text-red-400'
									]),
                            name: 
										record.valid !==
										'unknown'
											? 'check'
											: 'close'
									
                          }, null, 8, ["class", "name"])
                        ]),
                        _createElementVNode("p", _hoisted_10, _toDisplayString(record.record_type), 1),
                        _createElementVNode("p", _hoisted_11, _toDisplayString(record.name), 1),
                        _createElementVNode("p", _hoisted_12, _toDisplayString(record.value), 1),
                        _createElementVNode("p", _hoisted_13, _toDisplayString(record.cached[0]), 1)
                      ]),
                      (
								i !== _unref(sendingDns).length - 1
							)
                        ? (_openBlock(), _createBlock(_unref(UiLine), { key: 0 }))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_14, [
                  (!_unref(selectedEmail)?.valid)
                    ? (_openBlock(), _createBlock(_unref(UiButton), {
                        key: 0,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (
							_unref(verifyDomain)(
								_unref(selectedEmail)?.domain.id
							)
						)),
                        class: "ml-auto !h-9",
                        theme: "primary-outlined",
                        loading: _unref(verificationLoading)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Verify sending records ")
                        ]),
                        _: 1
                      }, 8, ["loading"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(UiCard), {
              theme: "white",
              class: "mt-8"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(UiCardDivider), {
                  title: "Danger zone",
                  subtitle: "By removing this email you won't be able to use it in messaging."
                }),
                _createVNode(_unref(UiButton), {
                  onClick: triggerDeleteCustomDomain,
                  theme: "danger-outlined"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Delete Email ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
    ]),
    _createVNode(_unref(UiConfirmation), {
      ref_key: "confirmationRef",
      ref: confirmationRef,
      loading: _unref(deleteLoading),
      onConfirm: deleteDomain
    }, null, 8, ["loading"])
  ], 64))
}
}

})